module.exports = __webpack_public_path__ + "static/media/canallightromain.3ca961d5.woff";